<app-content-container>
  <app-customers-banner [addButtonConfiguration]="addButtonConfiguration" />
  <app-customers-datatable
    data-testid="customers-datatable"
    [customers]="store.customers$()"
    [customersLoading]="store.customersLoading$()"
  />
</app-content-container>
